import React from 'react';
import { useSelector } from 'react-redux';
import ShoppingBasket from './shoppingbasket';
import { removeOrder, sendOrders, sendOrdersCombined, saveOrderToStore, autosaveOrder } from '../modules/orderdata';
import { getLocationFull } from '../modules/locationdata';
import useOrderAutosave from './useOrderAutosave';

const actions = { removeOrder, sendOrders, sendOrdersCombined, saveOrderToStore, autosaveOrder, getLocationFull };
const selectOrderState = (state) => state.orderdata;

export default function ShoppingBasketContainer(props) {
    const {
        pendingOrders,
        sendingOrdersInProgress,
        orderSendFailed,
        savingCombinedOrder,
        autosaving,
        autosavingFailed,
        unsavedChanges,
        orderChanged,
        removeOrder: removeOrderInt,
        sendOrders: sendOrdersInt,
        sendOrdersCombined: sendOrdersCombinedInt,
        getLocationFull: getLocationFullInt,
    } = useOrderAutosave({ selectOrderState, actions, retryTimeout: 5000 });

    const locationsById = useSelector((state) => state.locationdata.locationsById);
    const userProfile = useSelector((state) => state.authentication.userProfile);
    const parameters = useSelector((state) => state.parameterdata.parameters);

    return (
        <ShoppingBasket
            customerView={false}
            pendingOrders={pendingOrders}
            sendingOrdersInProgress={sendingOrdersInProgress}
            orderSendFailed={orderSendFailed}
            locationsById={locationsById}
            removeOrder={removeOrderInt}
            sendOrders={sendOrdersInt}
            sendOrdersCombined={sendOrdersCombinedInt}
            getLocationFull={getLocationFullInt}
            userProfile={userProfile}
            savingCombinedOrder={savingCombinedOrder}
            parameters={parameters}
            orderChanged={orderChanged}
            autosaving={autosaving}
            autosavingFailed={autosavingFailed}
            unsavedChanges={unsavedChanges}
        />
    );
}
